// @flow

const ensureArray = (value: *) => (Array.isArray(value) ? value : [value]);

export default ensureArray;
